import * as React from "react";

import { cn } from "@/lib/utils";

const DEFAULT_SHIELD_SRC = "https://cdn.monetary-metals.com/client-portal/staging/assets/shield_128x148.webp";

const LoadingSpinner = React.forwardRef<HTMLImageElement, React.ImgHTMLAttributes<HTMLImageElement>>(
  ({ src, className, ...props }, ref) => {
    return (
      <div className="absolute inset-0 z-10 h-screen">
        <div className="flex h-full flex-col items-center justify-center">
          <img
            ref={ref}
            src={src || DEFAULT_SHIELD_SRC}
            width={128}
            className={cn("animate-springy-spin", className)}
            {...props}
          />
        </div>
      </div>
    );
  },
);
LoadingSpinner.displayName = "LoadingSpinner";

export { LoadingSpinner };
